<template>
  <multiselect
      id="userOrg"
      :value="modelValue"
      @select="$emit('update:model-value', $event)"
      :options="searchUserOrg"
      value-prop="id"
      mode="single"
      track-by="id"
      label="displayName"
      :close-on-select="true"
      :filter-results="false"
      :min-chars="1"
      :resolve-on-load="true"
      :delay="500"
      :can-clear="false"
      :can-deselect="canDeselect"
      :searchable="true"
      :search-start="!initOrgData"
      :option-height="22"
      :no-options-text="$t('adm.multiselect.noItems')"
      class="stihl-user-org"
      :disabled="$props.disabled">

    <template #singlelabel="props">
      <div class="multiselect-single-label link">
        <span class="multiselect-single-label-text">{{ props.value?.displayName }}</span>
        <stihl-icon icon="status-error" v-tooltip="$t('adm.label.inactiveOrg')" v-if="props.value?.isInactive"/>
      </div>
    </template>

    <template #option="props">
      <span class="link">
        <span class="d-inline-block">{{ props.option.displayName }}</span>
        <stihl-icon icon="status-error" v-tooltip="$t('adm.label.inactiveOrg')" v-if="props.option?.isInactive"/>
      </span>
    </template>

  </multiselect>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Multiselect from '@vueform/multiselect';
import { DisplayableOrg } from '@/components/utils';
import Backend, { OrganizationData } from '@/components/backend';
import { mapState } from 'pinia';
import useAppStore from '@/components/store';
import StihlIcon from '@/components/ui/StihlIcon.vue';

export default defineComponent({
  name: 'Select1Organization',
  components: { StihlIcon, Multiselect },
  emits: ['update:model-value'],
  props: {
    modelValue: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    canDeselect: { type: Boolean, default: false },
    // optional: details of the initially selected organization
    initOrgData: { type: Object as PropType<OrganizationData>, default: null },
  },
  computed: {
    ...mapState(useAppStore, {
      myRole: 'getMyAdminRole',
    }),
  },
  methods: {
    async searchUserOrg(filter: string | null): Promise<DisplayableOrg[]> {
      //Logger.debug('select1org', 'search org', filter, this.modelValue);

      if (filter) { // search by free-text
        // Logger.debug('select1org', `search org by (text:${filter})`);
        return Backend.validateToken().then((api) => api
            .findOrganizations({ $search: filter, $select: 'id,name,crmNo,state' })
            .then((r) => r.data.map((x: OrganizationData) => new DisplayableOrg(x))));
      }
      // initial search

      if (this.initOrgData) {
        // Logger.debug('select1org', ' no search received org details from parent');
        return [new DisplayableOrg(this.initOrgData)];
      }
      if (this.modelValue) {
        // search by id
        const $filter = this.myRole === 'userAdmin' ? '' : `id == ${this.modelValue}`;
        //Logger.debug('select1org', `search org by (${$filter})`);
        return Backend.validateToken().then((api) => api
            .findOrganizations({ $filter, $select: 'id,name,crmNo,state' })
            .then((r) => r.data.map((x: OrganizationData) => new DisplayableOrg(x))));
      }

      return [];
    },
  },
});
</script>
